// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__8UzMr","info":"Card_info__17a9R"};